import { render } from "./SliderItem.vue?vue&type=template&id=165c6486&scoped=true"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"

import "./SliderItem.vue?vue&type=style&index=0&id=165c6486&lang=css"
import "./SliderItem.vue?vue&type=style&index=1&id=165c6486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165c6486"]])

export default __exports__